"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebouncedParams = useDebouncedParams;
exports.useData = useData;

var _react = require("react");

function useDebouncedParams(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = (0, _react.useState)(value);
  (0, _react.useEffect)(() => {
    if (typeof delay === "number") {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    }
  }, [JSON.stringify(value)]);
  return typeof delay === "number" ? debouncedValue : value;
}

const loadingResult = ["loading"];

function useData(dataFunction, params, options = {}) {
  const [result, setResult] = (0, _react.useState)(loadingResult);
  const [loading, setLoading] = (0, _react.useState)(true);
  const [reloadCounter, setReloadCounter] = (0, _react.useState)(0);
  const keepResultUntilLoaded = {
    onReload: false,
    onRepeatOnError: true,
    onRepeatOnSuccess: true,
    ...(options.keepResultUntilLoaded || {})
  };
  const debouncedParams = useDebouncedParams(params, options.debounce || null);
  (0, _react.useEffect)(() => {
    let errorRepeatCount = 0;
    let successRepeatCount = 0;
    const timers = [];

    function run() {
      setLoading(true);
      dataFunction(debouncedParams).then(value => {
        setLoading(false);
        setResult(["success", value]);

        if (options.repeatOnSucess) {
          const timeToRepeat = options.repeatOnSucess(value, successRepeatCount);

          if (timeToRepeat) {
            timers.push(window.setTimeout(() => {
              successRepeatCount += 1;

              if (!keepResultUntilLoaded.onRepeatOnSuccess) {
                setResult(loadingResult);
              }

              run();
            }, Math.max(timeToRepeat * 1000, 100)));
          }
        }
      }).catch(err => {
        setLoading(false);
        setResult(["error", String(err)]);

        if (options.repeatOnError) {
          const timeToRepeat = options.repeatOnError(String(err), errorRepeatCount);

          if (timeToRepeat) {
            timers.push(window.setTimeout(() => {
              errorRepeatCount += 1;

              if (!keepResultUntilLoaded.onRepeatOnError) {
                setResult(loadingResult);
              }

              run();
            }, Math.max(timeToRepeat * 1000, 100)));
          }
        }
      });
    }

    if (!keepResultUntilLoaded.onReload) {
      setResult(loadingResult);
    }

    run();
    return function cleanup() {
      timers.forEach(handle => {
        window.clearTimeout(handle);
      });
    };
  }, [JSON.stringify(debouncedParams), reloadCounter]);
  return {
    data: result,
    intermediateLoading: loading,
    reload: () => {
      setReloadCounter(reloadCounter + 1);
    }
  };
}
//# sourceMappingURL=useData.js.map